import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FLOATING_RESIZE_HANDLES } from './floatingPanelGeometry';
import PanelChrome from './PanelChrome';
import './styles.less';

const FloatingPanel = ({
	className,
	panelClassName,
	visible,
	displayedGeometry,
	isInteracting,
	startResize,
	header,
	children,
	zIndex = 1050
}) => {
	if (!visible) {
		return null;
	}

	const { x, y, width, height } = displayedGeometry;

	return (
		<div
			className={cx('floating-panel', panelClassName, className, {
				'floating-panel--interacting': isInteracting
			})}
			style={{
				left: x,
				top: y,
				width,
				height,
				zIndex
			}}
			role='dialog'
		>
			{FLOATING_RESIZE_HANDLES.map((handle) => (
				<div
					key={handle}
					className={cx('floating-panel__resize-handle', `floating-panel__resize-handle--${handle}`)}
					onPointerDown={(event) => startResize(handle, event)}
					aria-hidden
				/>
			))}
			<PanelChrome isInteracting={isInteracting} header={header}>
				{children}
			</PanelChrome>
		</div>
	);
};

FloatingPanel.propTypes = {
	className: PropTypes.string,
	panelClassName: PropTypes.string,
	visible: PropTypes.bool,
	displayedGeometry: PropTypes.shape({
		x: PropTypes.number,
		y: PropTypes.number,
		width: PropTypes.number,
		height: PropTypes.number
	}).isRequired,
	isInteracting: PropTypes.bool,
	startResize: PropTypes.func.isRequired,
	header: PropTypes.node.isRequired,
	children: PropTypes.node,
	zIndex: PropTypes.number
};

export default FloatingPanel;
